import React, { useState, useEffect, useRef } from 'react';
import { useResponsive } from 'components/responsive';
import { useDispatch, useSelector } from 'react-redux';
import { Layout, Popover, Tooltip, Breadcrumb, Modal, message, Input } from 'antd';
import { Link } from 'react-router-dom';
import { API_URL_V1 } from 'constants/ApiSetting';

import CustomScrollbars from 'util/CustomScrollbars';
import languageData from './languageData';
import { switchLanguage, toggleCollapsedSideNav } from '../../appRedux/actions/setting-actions';
import UserInfo from 'components/UserInfo';
import { userSignOut, checkSession } from 'appRedux/actions/Auth';
import { systemConfigSystemDateSet } from 'appRedux/actions/setup/systemSetup/systemConfig';
import SystemConfigState from 'hooks/systemConfig.state.hooks';
import { MdMenu } from 'react-icons/md';
import { IoIosArrowDown, IoIosArrowUp } from 'react-icons/io';
import Icon from '@mdi/react';
import { mdiFaceAgent } from '@mdi/js';
import flagSprite from 'assets/vendors/flag/sprite-flags-24x24.png';

import {
  NAV_STYLE_DRAWER,
  NAV_STYLE_FIXED,
  NAV_STYLE_MINI_SIDEBAR,
  NAV_STYLE_NO_HEADER_MINI_SIDEBAR,
  NAV_STYLE_NO_HEADER_EXPANDED_SIDEBAR,
  TAB_SIZE,
} from '../../constants/ThemeSetting';

import { Navi } from 'routes/main/route';
import OnlineTag from './Tags/OnlineTag';
import SystemDateTag from './Tags/SystemDateTag';
import CurrentTag from './Tags/CurrentTag';
import LicenseNotification from './License';
import TagWarning from './License/tagWarning';
import { useMessage } from 'util/messageLocalHook';
import * as signalR from '@microsoft/signalr';
import { NavHeader } from './styles/topbarStyle';
import FromasChatAssistant from 'components/FromasChatAssistant';
import PropertyInfoStateHook from '@/routes/main/setup/systemSetup/propertyInfo/propertyInfo.state.hook';
import { propertyPreview } from '@/appRedux/actions';
import { systemBannerSet } from 'appRedux/actions/systemBanner';
import cn from '@/utils/cn';
import NotificationBell from '@/components/NotificationBell/NotificationBell';

const { Header } = Layout;
const { TextArea } = Input;

const CHAT_SYSTEM_PROMPT =
  "You are FromasCloud's virtual assistant. Answer in Thai when the user writes in Thai, otherwise respond in the user's language. Provide concise, actionable help for hotel operations within the FromasCloud platform.";

interface TopbarProps {
  history: any;
}

const Topbar: React.FC<TopbarProps> = ({ history }) => {
  const { device } = useResponsive();
  const isIPad = device === 'ipad';

  const storedLocale = localStorage.getItem('locale');
  const initialLocale = storedLocale ? JSON.parse(storedLocale) : null;

  const [showCollapsNav, setShowCollapsNav] = useState(false);
  const [showChatInTopbar, setShowChatInTopbar] = useState(true); // Always show chat in topbar
  const [chatModalVisible, setChatModalVisible] = useState(false);
  const [userClickedChatIcon, setUserClickedChatIcon] = useState(false); // Track if user clicked the icon

  const dispatch = useDispatch();
  // call to set logo
  useEffect(() => {
    const getDataSource = async () => {
      dispatch(propertyPreview());
    };

    getDataSource();
  }, [dispatch]);

  const {
    dataSource: { logo },
  } = PropertyInfoStateHook();

  const {
    notifications,
    auth: { authUser, checkSessionResult },
    currentLocation: { markLocations },
  } = useSelector((state: any) => state);
  const {
    dataSource: { SYSTEM, license_info },
  } = SystemConfigState();

  const { t } = useMessage();

  if (!authUser) dispatch(userSignOut());

  const hotelName = authUser?.prop_name;
  const prop_code = authUser?.prop_code?.toLowerCase();
  const user_name = authUser?.user_name?.toLowerCase();

  const { dataSource } = notifications;

  const { navStyle } = useSelector(({ settings }: any) => settings);
  const { locale: reduxLocale } = useSelector(({ settings }: any) => settings);
  // Fallback to English if no locale is set
  const defaultLocale =
    languageData.find((lang) => lang.languageId === 'english') || languageData[0];
  const locale = initialLocale || reduxLocale || defaultLocale;
  const { navCollapsed, width } = useSelector(({ common }: any) => common);
  const [popOverToggle, setPopOverToggle] = useState(false);
  const [languagePopoverOpen, setLanguagePopoverOpen] = useState(false);

  const [endOfDayModalVisible, setEndOfDayModalVisible] = useState(false);

  const localeRef = useRef(locale);
  localeRef.current = locale;

  const RouteNavigator = Navi(history.location.pathname);
  /*
  useEffect(()=>{
    dispatch(notificationPreview())
  },[dispatch])
  */

  // Always show chat in topbar - no need to check localStorage
  // useEffect(() => {
  //   // Check if chat should be shown in topbar (from localStorage)
  //   const chatMovedToTopbar = localStorage.getItem('chatMovedToTopbar');
  //   if (chatMovedToTopbar === 'true') {
  //     setShowChatInTopbar(true);
  //   }
  // }, []);

  // localeRef ใช้เพื่อให้ callback ใน SignalR อ่านค่า locale ล่าสุดได้เสมอ โดยไม่ต้องใส่ locale ใน deps
  // ถ้าใส่ locale ใน deps จะทำให้ effect re-run ทุกครั้งที่เปลี่ยนภาษา และเกิด listener ซ้อนทับ
  // เพราะ connection เก่าไม่ถูก stop ก่อนที่จะสร้าง connection ใหม่
  useEffect(() => {
    // Initialize SignalR connection
    const newConnection = new signalR.HubConnectionBuilder()
      .withUrl(process.env.REACT_APP_REALTIME_URL || '', {
        skipNegotiation: true,
        transport: signalR.HttpTransportType.WebSockets,
      })
      .build();

    // Start the connection
    newConnection
      .start()
      .then(() => {
        console.log('SignalR connection started');
      })
      .catch((err) => {
        console.error('มีปัญหาในการเชื่อมต่อท่อ: ' + err);
        return;
      });

    //Handling incoming messages
    newConnection.on(`test-aonestar-${prop_code}-${user_name}`, (result) => {});

    newConnection.on('endsdayMsg', (result) => {});

    newConnection.on(`endday_start-${prop_code}-*`, (result) => {
      /*
      example response
      {
      "user_name": "Pisanu",
      "start_time": "2025-06-13T14:39:40.402012+07:00"
      }
      */
      try {
        if (user_name?.toLowerCase() !== result.user_name?.toLowerCase()) {
          setEndOfDayModalVisible(true);
        }
      } catch (error) {}
    });

    newConnection.on(`system_date_changed-${prop_code}-*`, (result) => {
      /*
      exmaple response
      { "SYSTEM_DATE": "2025-06-12" }
      */
      try {
        dispatch(systemConfigSystemDateSet(result));
      } catch (error) {}
    });

    newConnection.on(`system_alert-${prop_code}-*`, (result) => {
      /*
      example response
      {
        "system":   { "type": "info", "message_en": "...", "message_th": "..." },
        "property": { "type": "info", "message_en": "...", "message_th": "..." }
      }
      */
      try {
        const localeCode: string = localeRef.current?.locale ?? 'en';
        const resolve = (item: any) => {
          if (!item) return null;
          return {
            type: item.type,
            message: localeCode === 'th' ? item.message_th : item.message_en,
          };
        };
        dispatch(
          systemBannerSet({
            system: resolve(result.system),
            property: resolve(result.property),
          })
        );
      } catch (error) {}
    });

    return () => {
      newConnection.stop();
    };
  }, [prop_code, user_name, dispatch]);

  const handleLanguageSelect = async (language: any) => {
    try {
      localStorage.setItem('locale', JSON.stringify(language));
      dispatch(switchLanguage(language));
      setPopOverToggle(false);
      setLanguagePopoverOpen(false);

      const languageCode = (language?.locale || '').toUpperCase();
      if (!languageCode) {
        console.warn('[Language Select] No language code found');
        return;
      }

      const accessToken = localStorage.getItem('access_token') || '';
      const headers: any = {
        'Content-Type': 'application/json',
        'x-api-key': process.env.REACT_APP_API_KEY || '',
      };

      if (accessToken) {
        headers.Authorization = `Bearer ${accessToken}`;
      }

      const requestPayload = {
        language: languageCode,
      };

      const response = await fetch(`${API_URL_V1}auth/rpc/user/update_language`, {
        method: 'POST',
        headers,
        body: JSON.stringify(requestPayload),
      });

      const responseBody = await response.json().catch((error) => {
        console.error('[Language Select] Failed to parse response:', error);
        return null;
      });

      if (response.status === 200) {
        const resultMsg =
          responseBody?.data?.result_data?.result_msg ||
          responseBody?.data?.result_msg ||
          'ปรับภาษาสำเร็จ';

        message.success(resultMsg);
      } else {
        const { message: errorMessage, data } = responseBody || {};

        console.error('[Language Select] Error Response:', {
          status: response.status,
          errorMessage,
          data,
          fullResponse: responseBody,
        });

        if (response.status === 403) {
          /* if data is not null force signout */
          if (data) {
            dispatch(userSignOut());
          } else {
            message.error(errorMessage || 'ไม่สามารถบันทึกภาษาที่เลือกได้ กรุณาลองอีกครั้ง');
          }
        } else {
          message.error(errorMessage || 'ไม่สามารถบันทึกภาษาที่เลือกได้ กรุณาลองอีกครั้ง');
        }
      }
    } catch (error) {
      console.error('[Language Select] Exception:', error);
      message.error('ไม่สามารถบันทึกภาษาที่เลือกได้ กรุณาลองอีกครั้ง');
    }
  };

  const languageMenu = () => {
    const flagSpriteUrl = flagSprite;

    return (
      <CustomScrollbars
        className='gx-popover-lang-scroll'
        renderView={(props: any) => (
          <div
            {...props}
            style={{
              ...props.style,
              position: 'relative',
              inset: 'auto',
            }}
          />
        )}
      >
        <style>
          {`
    .gx-popover-lang-scroll {
      width: 120px !important;
      max-height: 100px !important;
      padding: 0 !important;
      margin: 0 !important;
      position: relative !important;
    }

    .gx-popover-lang-scroll > div {
      position: relative !important;
    }

    .gx-popover-lang-scroll .react-custom-scrollbars-view {
      position: relative !important;
    }

    .gx-popover-lang-scroll .react-custom-scrollbars-track-vertical {
      position: absolute !important;
    }

    .gx-sub-popover {
      padding: 0;
      margin: 0;
      list-style: none;
    }

    .gx-sub-popover li {
      padding: 6px 12px;
      margin: 0;
      height: 32px;
      display: flex;
      align-items: center;
      gap: 8px;
      font-size: 14px;
      cursor: pointer;
    }

    .gx-sub-popover li:hover {
      background-color: #f5f5f5;
    }

    .gx-language-text {
      line-height: 1;
    }

    .ant-popover-inner-content {
      height: unset !important;
    }

    .flag {
      display: inline-block !important;
      width: 24px !important;
      height: 24px !important;
      flex-shrink: 0;
    }

    .flag.flag-24 {
      background-image: url(${flagSpriteUrl}) !important;
      background-repeat: no-repeat !important;
    }
  `}
        </style>
        <ul className='gx-sub-popover'>
          {languageData && languageData.length > 0 ? (
            languageData.map((language, index) => {
              // Get background-position based on icon
              const getBackgroundPosition = (icon: string) => {
                switch (icon) {
                  case 'us':
                    return '-168px -336px';
                  case 'th':
                    return '-240px -312px';
                  case 'cn':
                    return '-336px -72px';
                  default:
                    return '-168px -336px'; // Default to US
                }
              };

              return (
                <li
                  className='gx-media gx-pointer'
                  key={JSON.stringify(language)}
                  onClick={() => {
                    handleLanguageSelect(language);
                  }}
                >
                  <i
                    className={`flag flag-24 gx-mr-2 flag-${language.icon || 'us'}`}
                    style={{
                      display: 'inline-block',
                      width: 24,
                      height: 24,
                      flexShrink: 0,
                      backgroundImage: `url(${flagSprite})`,
                      backgroundRepeat: 'no-repeat',
                      backgroundPosition: getBackgroundPosition(language.icon || 'us'),
                    }}
                  />
                  <span className='gx-language-text'>{language.name || 'Language'}</span>
                </li>
              );
            })
          ) : (
            <li className='gx-media' style={{ padding: '12px', color: '#999' }}>
              <span>No languages available</span>
            </li>
          )}
        </ul>
      </CustomScrollbars>
    );
  };

  const handleVisibleChange = (value: boolean) => {
    setPopOverToggle(value);
  };

  const handleClose = () => {
    setPopOverToggle(false);
  };

  const handleChatToggle = (visible: boolean) => {
    setChatModalVisible(visible);
  };

  const handleChatIconClick = () => {
    // Mark that user clicked the icon
    setUserClickedChatIcon(true);
    // Dispatch checkSession action - saga will handle everything
    // If session is invalid (403), saga will automatically sign out
    // If session is valid, checkSessionSuccess will be dispatched
    dispatch(checkSession(''));
  };

  // Listen for checkSession success to open chat modal ONLY if user clicked the icon
  useEffect(() => {
    // Only open modal if user clicked the icon AND session is valid
    if (userClickedChatIcon && checkSessionResult) {
      const { valid } = checkSessionResult;
      if (valid && authUser) {
        // Session is valid and user clicked icon, open chat modal
        setChatModalVisible(true);
        // Reset the flag after opening modal
        setUserClickedChatIcon(false);
      }
      // If invalid, user will be signed out automatically by saga
      // Reset the flag even if invalid
      setUserClickedChatIcon(false);
    }
  }, [checkSessionResult, authUser, userClickedChatIcon]);

  // No longer needed - chat is always in topbar
  // const handleMoveToTopbar = () => {
  //   setShowChatInTopbar(true);
  //   localStorage.setItem('chatMovedToTopbar', 'true');
  // };

  const handleModalCloseAndLogout = () => {
    dispatch(userSignOut());
    setEndOfDayModalVisible(false);
  };

  const compactNavStyles = [
    NAV_STYLE_FIXED,
    NAV_STYLE_MINI_SIDEBAR,
    NAV_STYLE_NO_HEADER_MINI_SIDEBAR,
    NAV_STYLE_NO_HEADER_EXPANDED_SIDEBAR,
  ];

  const shouldShowMenuToggle =
    navStyle === NAV_STYLE_DRAWER ||
    (compactNavStyles.includes(navStyle) && (isIPad || (!isIPad && width < TAB_SIZE)));

  const toggleShowCollapsNav = () => {
    setShowCollapsNav(!showCollapsNav);
  };

  return (
    <>
      <style>
        {`
          .flag.flag-24 {
            background-image: url(${flagSprite}) !important;
            background-repeat: no-repeat !important;
            display: inline-block !important;
            width: 24px !important;
            height: 24px !important;
          }
        `}
      </style>
      <NavHeader>
        {/* Manu, Logo, Title, Breadcrumb */}
        <div className='left'>
          <div className='gx-linebar'>
            <button
              className='menu'
              style={shouldShowMenuToggle ? { display: 'grid' } : undefined}
              onClick={() => {
                dispatch(toggleCollapsedSideNav(!navCollapsed));
              }}
            >
              <MdMenu />
            </button>
          </div>
          <div className='logo-container'>
            {/* icon */}
            <div
              style={{
                width: '35px',
                height: '35px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                overflow: 'hidden',
                borderRadius: '4px',
                flexShrink: 0,
              }}
            >
              <Link
                to='#'
                className='gx-d-block gx-pointer'
                style={{
                  width: '100%',
                  height: '100%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <img
                  alt='Newsoft Hotel Logo'
                  src={logo || require('assets/images/FROMAS_S.png')}
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'contain',
                    objectPosition: 'center',
                    display: 'block',
                  }}
                />
              </Link>
            </div>
            {/* Title and breadcrumb */}
            <div className='title-container'>
              <p className='title'>
                {hotelName || 'Newsoft Hotel'}
                <TagWarning />
              </p>
              {RouteNavigator.length > 1 && (
                <Breadcrumb
                  style={{
                    fontSize: 12,
                    color: '#64748b',
                  }}
                >
                  {RouteNavigator.map((obj: any, index: number) => (
                    <Breadcrumb.Item key={obj.pathName}>
                      {markLocations.includes(history.location.pathname) ? (
                        <span style={{ fontWeight: 500 }}>{obj.title}</span>
                      ) : (
                        <span style={{ fontWeight: 500 }}>
                          {' '}
                          <Link to={obj.linkTo}>{obj.title}</Link>
                        </span>
                      )}
                    </Breadcrumb.Item>
                  ))}
                </Breadcrumb>
              )}
            </div>
          </div>
        </div>
        {/* Right button */}
        <ul
          className={cn(
            'flex items-center justify-center gap-2',
            !showCollapsNav && 'hidden lg:flex'
          )}
        >
          <li className='flex items-center'>
            <CurrentTag />
          </li>
          {SYSTEM?.ONLINE_POST && (
            <li className='flex items-center'>
              <OnlineTag />
            </li>
          )}
          <li className='flex items-center'>
            <SystemDateTag />
          </li>
          {/* Separator | */}
          <li className='hidden md:flex justify-center h-[20px] md:mx-2'>
            <span className='border-r border-slate-500 h-full'></span>
          </li>
          <li className='flex items-center'>
            <NotificationBell />
          </li>
          <li className='flex items-center'>
            <Popover
              classNames={{ root: 'gx-popover-horizantal' }}
              placement='bottomRight'
              content={languageMenu()}
              trigger='click'
              open={languagePopoverOpen}
              onOpenChange={setLanguagePopoverOpen}
            >
              <span className='inline-flex items-center justify-center w-[36px] h-[36px] rounded-[10px] cursor-pointer hover:bg-[#f0f5ff] transition-colors duration-150'>
                {(() => {
                  const currentIcon = (locale && locale.icon) || defaultLocale?.icon || 'us';
                  const getBackgroundPosition = (icon: string) => {
                    switch (icon) {
                      case 'us':
                        return '-168px -336px';
                      case 'th':
                        return '-240px -312px';
                      case 'cn':
                        return '-336px -72px';
                      default:
                        return '-168px -336px';
                    }
                  };

                  return (
                    <i
                      className={`flag flag-24 flag-${currentIcon}`}
                      style={{
                        display: 'inline-block',
                        width: 24,
                        height: 24,
                        flexShrink: 0,
                        backgroundImage: `url(${flagSprite})`,
                        backgroundRepeat: 'no-repeat',
                        backgroundPosition: getBackgroundPosition(currentIcon),
                      }}
                    />
                  );
                })()}
              </span>
            </Popover>
          </li>
          {/* <li className='gx-help' style={{ marginRight: 6, marginTop: 3 }}>
          <Tooltip title='Help & Manual'>
            <i
              className='icon icon-question-circle gx-pointer'
              style={{ fontSize: 26, color: '#1890ff' }}
              onClick={() => {
                const url = 'https://docs.fromas.cloud/books/fromas-cloud-user-manual/page/a8baa';
                window.open(url, '_blank', 'noopener,noreferrer');
              }}
            />
          </Tooltip>
        </li> */}
          {/* Chat Button in Topbar */}
          {showChatInTopbar && (
            <li className='flex items-center'>
              <Tooltip title='Fromas Support'>
                <span
                  className='inline-flex items-center justify-center w-[36px] h-[36px] rounded-[10px] cursor-pointer hover:bg-[#f0f5ff] transition-colors duration-150'
                  onClick={handleChatIconClick}
                >
                  <Icon
                    path={mdiFaceAgent}
                    size={1}
                    style={{
                      color: '#1890ff',
                      filter: 'drop-shadow(0 1px 2px rgba(24, 144, 255, 0.3))',
                    }}
                  />
                </span>
              </Tooltip>
            </li>
          )}
          <li className='flex items-center mr-2'>
            <UserInfo />
          </li>
        </ul>
        {/* Toggle show collaps nav */}
        <button className='toggle-show' onClick={toggleShowCollapsNav}>
          {showCollapsNav ? <IoIosArrowUp /> : <IoIosArrowDown />}
        </button>

        {/* Chat Modal - Render outside NavHeader to avoid z-index issues */}
        {showChatInTopbar && (
          <FromasChatAssistant
            open={chatModalVisible}
            onOpenChange={setChatModalVisible}
            onClose={() => setChatModalVisible(false)}
            showFloatingButton={false}
          />
        )}

        {/* End of Day Modal */}
        <Modal
          title='End of Day Processing'
          open={endOfDayModalVisible}
          onOk={handleModalCloseAndLogout}
          onCancel={handleModalCloseAndLogout}
          okText='OK'
          cancelText='Cancel'
        >
          <p>Another user has started End of Day processing. You will be logged out.</p>
        </Modal>
      </NavHeader>
    </>
  );
};

export default Topbar;
